import { useEffect, useState } from "react";
import { constants, messages } from "../../common/constants";
import withUser from "../../redux/HOC/withUser";
import ContractMaintenanceGrid from "./Grid";
import { updateContractMaintenance } from "../../utils/API";
import swal from "sweetalert";
import { RateChangeDefs } from "../../common/rateChange";
import { validateRate } from "../../common/tradeValidations";
import _ from "lodash";

interface ContractMaintenanceProps {
  user: any;
  selectedRows: any;
  cmType: any;
  updateGridCells: any;
  setUpdatedRowIds: any;
  //closeUpdateContract: any;
  setDoShowFullScreenLoader: any;
  doShowFullScreenLoader: any;
  handleCMPopupClose: any;
}

const ContractMaintenance = ({
  user,
  selectedRows,
  cmType,
  updateGridCells,
  setDoShowFullScreenLoader,
  setUpdatedRowIds,
  doShowFullScreenLoader,
  handleCMPopupClose
}: // closeUpdateContract,
  ContractMaintenanceProps) => {
  const heightAG_1 = 30;
  // const [doShowFullScreenLoader, setDoShowFullScreenLoader] =
  //   useState<boolean>(false);
  const [rateChangeType, setRateChangeType] = useState<any>(
    constants.RATE_CHANGE_INLINE
  );
  const [rateValue, setRateValue] = useState<any>(null);
  const [fromRateValue, setFromRateValue] = useState<any>(null);
  const [toRateValue, setToRateValue] = useState<any>(null);
  const [contracts, setContracts] = useState<any>(selectedRows);
  const [currentColumnDefs, setCurrentColumnDefs] =
    useState<any>(RateChangeDefs);
  const [isValidRequest, setIsValidRequest] = useState<boolean>(false);
  const [pcValue, setPCValue] = useState<string>("");
  const [isValidInput, setIsValidInput] = useState<boolean>(true);
  const [filteredRows, setFilteredRows] = useState<any>(selectedRows);
  const [isRateRangeValid, setIsRateRangeValid] = useState<boolean>(true);
  const [gridApi, setGridApi] = useState<any>(null);
  const [columnApi, setColumnApi] = useState<any>(null);

  const updateContract = async () => {
    try {
      setDoShowFullScreenLoader(true);
      if (contracts && contracts?.length > 0) {
        let rows: any[] = [];
        let errors: any[] = [];
        if (cmType === constants?.PROFIT_CENTER) {
          rows = contracts.map((r: any) => ({
            contractId: r?.contract_id,
            action: cmType,
            bl: r?.contract_type,
            changes: [
              {
                attribute: cmType,
                value: /[a-z]/gm.test(r?.newValue) ? r?.newValue?.toUpperCase() : r?.newValue
              }
            ]
          }));
        } else if (cmType === constants?.ADMIN_RATE) {
          rows = filteredRows.map((r: any) => ({
            contractId: r?.contract_id,
            action: constants.REBATE_RATE,
            bl: r?.contract_type,
            changes: [
              {
                attribute: constants.REBATE_RATE,
                value: r?.newValue
              }
            ]
          }));
        } else if (cmType === constants?.MARK_TO_MARKET) {
          rows = contracts.map((r: any) => ({
            contractId: r?.contract_id,
            action: cmType,
            bl: r?.contract_type,
            contractPrice: r.newValue,
            changes: [
              {
                attribute: cmType,
                value: (r.quantity * r.newValue)?.toFixed(2)
              }
            ]
          }));
        } else {
          rows = contracts.map((r: any) => ({
            contractId: r?.contract_id,
            action: cmType,
            bl: r?.contract_type,
            changes: [
              {
                attribute: cmType,
                value: r?.newValue
              }
            ]
          }));
        }

        if (rows && rows?.length >= 0) {
          const accessToken = window.localStorage.getItem("refreshtoken");
          const response = await updateContractMaintenance(
            rows,
            user?.tokenType,
            accessToken
          );
          if (response?.status === 200) {
            setUpdatedRowIds(_.map(contracts, "id"));
            updateGridCells(rows)
            let cmUpdateResponse = await response?.json();
            cmUpdateResponse?.forEach((obj: any) => {
              if (obj.hasError === true) {
                errors.push(obj.status + " " + obj.error);
              }
            });
            if (errors.length > 0) {
              errors = _.uniq(errors);
              let error = messages.statuserror + "\n\n Error(s): \n";
              errors.map((e: any) => {
                error = error + e + "\n";
              });
              swal({
                title: constants.Error,
                text: error,
                dangerMode: true,
                closeOnClickOutside: false,
              });
            }
            handleCMPopupClose();
          }
        }
      }
    } catch (err) {
      setDoShowFullScreenLoader(false);
    } finally {
      setDoShowFullScreenLoader(false);
      //closeUpdateContract();
    }
  };

  const onUpdateCell = (data: any, value: any) => {
    try{
      switch(cmType){
        case constants.PROFIT_CENTER:
          data.newValue = value && /[a-z]/gm.test(value) ? value?.toUpperCase() : value;
          if (
            value &&
            value?.length === 1 &&
            /[A-Za-z0-9 !@#$%&*()+=?]/gm.test(value)
          ) {
            data.hasError = false;
    
          } else {
            data.hasError = true;
          }
          break;
        case constants.REBATE_RATE:
          if (value && !_.isNaN(value) && validateRate((parseFloat(value))?.toFixed(4))) {
            data.hasError = false;
            data.newValue = (parseFloat(value))?.toFixed(4)
          } else {
            data.hasError = true;
          }
          break;
        case constants.MARK_TO_MARKET:
          if (value && !isNaN(value) && parseFloat(value) > 0) {
            data.hasError = false;
            let contractPrice = data?.quantity * parseFloat(value);
            if (contractPrice > 999999999999.99) {
              data.hasError = true;
            }
            data.newContractValue = data.quantity * value;
          } else {
            data.hasError = true;
            data.newContractValue = null;
          }
          break;
        
          case constants.ADMIN_RATE:
            if (value && validateRate(value)) {
              data.hasError = false;
      
            } else {
              data.hasError = true;
            }
            
            break;
          default:
  
      }
    }catch(err){
      console.log(err)
    }finally{
      if(cmType === constants.ADMIN_RATE){
        setFilteredRows((previousRows: any) => {
          let index = previousRows?.findIndex(
            (x: any) =>
              x?.id === data?.id && x.contract_type === data?.contract_type
          );
          if (index >= 0) {
            previousRows[index] = data;
          }
          let errorIndex = previousRows?.findIndex((x: any) => x.hasError === true || (_.isEmpty(x.newValue) || !x.newValue));
          setIsValidRequest(errorIndex === -1);
          return previousRows;
        });
      }else{
        setContracts((previousRows: any) => {
          let index = previousRows?.findIndex(
            (x: any) =>
              x?.id === data?.id && x.contract_type === data?.contract_type
          );
          if (index >= 0) {
            previousRows[index] = data;
          }
          
          if(cmType === constants.REBATE_RATE ||
             cmType === constants.ADMIN_RATE || cmType === constants.MARK_TO_MARKET){
              let errorIndex = previousRows?.findIndex((x: any) => x.hasError === true || (_.isEmpty(x.newValue) || !x.newValue));
              setIsValidRequest(errorIndex === -1);
          }
         else{
          let errorIndex = previousRows?.findIndex((x: any) => x.hasError === true);
          setIsValidRequest(errorIndex === -1);
         }
    
          return previousRows;
        });
      }
    }

  };

  const applyRate = () => {
    let rows: any[] = [];
    if (rateChangeType === constants.RATE_CHANGE_INLINE) {
      rows = [];
      rows = [...contracts]?.map((item: any) => {
        return {
          ...item,
          newValue: (parseFloat(rateValue))?.toFixed(4),
        };
      });
    } else if (rateChangeType === constants.RATE_CHANGE_RELATIVE) {
      rows = [];
      rows = [...contracts]?.map((item: any) => {
        return {
          ...item,
          newValue: (parseFloat(item.rate) + parseFloat(rateValue))?.toFixed(4),
        };
      });
    }
    const validatedRows = [...rows]?.map((item: any) => {
      return {
        ...item,
        hasError: !validateRate(item?.newValue),
      };
    });

    let index = validatedRows?.findIndex((x: any) => x.hasError === true);
    if (index === -1) {
      setIsValidRequest(true);
    } else {
      setIsValidRequest(false);
    }
    setContracts(validatedRows);
  };

  const applyPC = () => {
    let list = [...contracts];
    let rows = list?.map((item: any) => {
      return {
        ...item,
        newValue: pcValue,
      };
    });
    setIsValidInput(true);
    setIsValidRequest(true);
    setContracts(rows);
  };

  const validatePC = (pc: string) => {
    if (pc && (pc?.length > 1 || !/[A-Za-z0-9 !@#$%&*()+=?]/gm.test(pc))) {
      setIsValidInput(false);
    } else {
      setIsValidInput(true);
    }
  };

  const onChangeRateType = (rateType: string) => {
    setRateChangeType(rateType);
    if (rateType === constants.RATE_CHANGE_INLINE) {
      setRateValue("");
    }
  };

  const onRateFilterChange = () => {
    if (validateRate(fromRateValue) && validateRate(toRateValue)) {
      let fRows = [...contracts]?.filter(
        (c: any) =>
          parseFloat(c?.rate) >= fromRateValue &&
          parseFloat(c?.rate) <= toRateValue
      );
      setFilteredRows(fRows);
    } else {
      setFilteredRows(contracts);
    }
  };

  useEffect(() => {
    if (fromRateValue && toRateValue) {
      if (parseFloat(fromRateValue) <= parseFloat(toRateValue)) {
        setIsRateRangeValid(true);
      } else {
        if (validateRate(fromRateValue) && validateRate(toRateValue)) {
          setIsRateRangeValid(false);
        } else {
          setIsRateRangeValid(true);
        }
      }
    } else {
      setIsRateRangeValid(true);
    }
    onRateFilterChange();
  }, [fromRateValue, toRateValue]);

  const applyRerateRate = () => {
    let rows = [];
    rows = [...filteredRows]?.map((item: any) => {
      return {
        ...item,
        newValue: (parseFloat(item.rate) + parseFloat(rateValue))?.toFixed(4),
      };
    });
    const validatedRows = [...rows]?.map((item: any) => {
      return {
        ...item,
        hasError: item?.newValue && !validateRate(item?.newValue),
      };
    });

    let index = validatedRows?.findIndex((x: any) => x.hasError === true);
    if (index === -1) {
      setIsValidRequest(true);
    } else {
      setIsValidRequest(false);
    }
    setFilteredRows(validatedRows);
  };

  const onKeyDownFocusPC = (e: any) => {

    if(e.key === "Tab" && (pcValue && isValidInput)){
      if (e.key === "Tab" && (pcValue && isValidInput)) {
        window.setTimeout(function () {
          document.getElementById("pcApplyBtn")?.focus();
        }, 0);
      }
    }
    else{
      getFocusToEditalbeColumn(e)
    }
  }

  const keyDownFocusRebateRate = (e: any)=> {
    if (e.key === "Tab" && (rateValue && validateRate(rateValue))) {
      window.setTimeout(function () {
        document.getElementById("rateApplyBtn")?.focus();
      }, 0);
    }
    else{
      getFocusToEditalbeColumn(e)
    }
  }

  const keyDownFocusFromApply = (e:any)=>{
    getFocusToEditalbeColumn(e);
  }

  const getFocusToEditalbeColumn = (e:any)=>{
    if (e.key === "Tab" && isValidRequest) {
      window.setTimeout(function () {
        document.getElementById("submit")?.focus();
      }, 0);
    } else {
      if(e?.key !== 'Tab') return;
 
      // prevents tabbing into the url section
      e?.preventDefault();
      // scrolls to the first row
      gridApi?.ensureIndexVisible(0);
        
      // scrolls to the first column
      const columnList = columnApi?.getAllDisplayedColumns();
      let column = columnList?.find((x:any)=>x?.colId === 'newValue');
      if(column){
        gridApi?.ensureColumnVisible(column);
        // sets focus into the first grid cell
        gridApi?.setFocusedCell(0,column);
      }
    }

  }

  const focusOnInit = ()=> {
    switch(cmType){
      case constants.PROFIT_CENTER:
        window.setTimeout(function () {
          document?.getElementById("pc")?.focus();
        }, 0);
        break;
      case constants.REBATE_RATE:
      case constants.ADMIN_RATE:
        window.setTimeout(function () {
          document?.getElementById("rateChange")?.focus();
        }, 0);
        break;
    }
  }

  useEffect(()=>{
    focusOnInit();
  },[])
  
  return (
    <>
      {/* {doShowFullScreenLoader && <SpinnerFullScreen></SpinnerFullScreen>} */}
      {cmType === constants.REBATE_RATE && (
        <div className="d-flex flex-row mb-2">
          <div className="ms-2 h-100 d-flex mt-1 justify-content-start align-items-start">
            <div className="ms-2">
              <input
                type="radio"
                id="relative"
                checked={rateChangeType === constants.RATE_CHANGE_RELATIVE}
                value={rateChangeType}
                onChange={() =>
                  onChangeRateType(constants.RATE_CHANGE_RELATIVE)
                }
              />
              <label htmlFor="relative">Relative</label>
            </div>
            <div className="ms-2">
              <input
                type="radio"
                id="inline"
                checked={rateChangeType === constants.RATE_CHANGE_INLINE}
                value={rateChangeType}
                onChange={() => onChangeRateType(constants.RATE_CHANGE_INLINE)}
              />
              <label htmlFor="inline">Inline</label>
            </div>
          </div>
          <div className="d-flex justify-content-end ms-2">
            <div className="d-flex flex-column">
              <div>
                <input
                  className="input-style inputBorderNone"
                  type="number"
                  name="rateChange"
                  id="rateChange"
                  onInput={(event: any) => {
                    setRateValue(event?.target?.value);
                  }}
                  value={rateValue}
                  placeholder="Enter New Rate (%)"
                  style={{ height: "2.2rem" }}
                  onKeyDown={keyDownFocusRebateRate}
                />
              </div>
              {rateValue && !validateRate(rateValue) && (
                <div>
                  <span className="ms-2 error-style">
                    Please enter valid rate
                  </span>
                </div>
              )}
            </div>
            <div className="h-100 d-flex align-items-center">
              <button
                className={"btn btn-outline-primary outline-btn"}
                style={{ marginTop: "-2px" }}
                onKeyDown={keyDownFocusFromApply}
                disabled={!rateValue || (rateValue && !validateRate(rateValue))}
                onClick={() => {
                  applyRate();
                }}
                id="rateApplyBtn"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
      {cmType === constants.PROFIT_CENTER && (
        <div>
          <div className="d-flex flex-row">
            <label style={{ fontWeight: "600" }}>New PC</label>
            <div className="d-flex flex-column">
              <div>
                <input
                  className="h-100 ms-2 input-style inputBorderNone"
                  type="text"
                  name="pc"
                  id="pc"
                  style={{ textTransform: "uppercase" }}
                  onInput={(event: any) => {
                    if (
                      event?.target?.value &&
                      /[a-z]/gm.test(event?.target?.value)
                    ) {
                      setPCValue(event?.target?.value?.toUpperCase());
                      validatePC(event?.target?.value?.toUpperCase());
                    } else {
                      setPCValue(event?.target?.value);
                      validatePC(event?.target?.value);
                    }
                  }}
                  onKeyDown={onKeyDownFocusPC}
                  placeholder="Enter PC"
                />
              </div>
              <div className="justify-content-end">
                {pcValue && !isValidInput && (
                  <span className="ms-2 error-style">
                    Please enter valid profit center
                  </span>
                )}
              </div>
            </div>

            <div className="d-flex justify-content-start">
              <div className="h-75 d-flex align-items-center metrics-div">
                <button
                  disabled={!pcValue || !isValidInput}
                  className={
                    "btn btn-outline-primary outline-btn justify-content-center align-items-center"
                  }
                  onClick={() => {
                    applyPC();
                  }}
                  onKeyDown={keyDownFocusFromApply}
                  style={{ height: "2.25rem", textAlign: "center" }}
                  id="pcApplyBtn"
                >Apply
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {cmType === constants.ADMIN_RATE && (
        <div className="d-flex flex-row mb-2 justify-content-between">
          <div className="d-flex flex-row justify-content-start">
            <label className="mt-1" style={{ fontWeight: "600" }}>
              Relative Rate
            </label>
            <div className="d-flex flex-column">
              <input
                className="ms-2 input-style inputBorderNone"
                type="number"
                name="rateChange"
                id="rateChange"
                onInput={(event: any) => {
                  setRateValue(event?.target?.value);
                }}
                placeholder="Enter New Rate (%)"
                style={{ height: "2.2rem" }}
              />
              {rateValue && !validateRate(rateValue) && (
                <div>
                  <span className="ms-2 error-style">
                    Please enter valid rate
                  </span>
                </div>
              )}
            </div>
            <div className="ms-2 h-100 d-flex align-items-center">
              <button
                className={"btn btn-outline-primary outline-btn mb-3"}
                disabled={!rateValue || (rateValue && !validateRate(rateValue))}
                onClick={() => {
                  applyRerateRate();
                }}
                onKeyDown={keyDownFocusFromApply}
              >
                Apply
              </button>
            </div>
          </div>
          <div className="d-flex flex-row ms-2">
            <label className="mt-1" style={{ fontWeight: "600" }}>
              From Rate
            </label>
            <div>
              <div className="d-flex flex-column">
                <input
                  className="ms-2 input-style inputBorderNone"
                  type="number"
                  name="fromRate"
                  id="fromRate"
                  onInput={(event: any) => {
                    setFromRateValue(event?.target?.value);
                  }}
                  placeholder="Enter From Rate (%)"
                  style={{ height: "2.2rem" }}
                />
                {fromRateValue && !validateRate(fromRateValue) && (
                  <div className="ms-2 error-style">
                    Please enter valid rate
                  </div>
                )}
                {!isRateRangeValid && (
                  <div>
                    <span className="ms-2 error-style">
                      Please enter valid rate range
                    </span>
                  </div>
                )}
              </div>
            </div>
            <label className="mt-1" style={{ fontWeight: "600" }}>
              To Rate
            </label>
            <div className="d-flex flex-column">
              <input
                className="ms-2 input-style inputBorderNone"
                type="number"
                name="toRate"
                id="toRate"
                onInput={(event: any) => {
                  setToRateValue(event?.target?.value);
                }}
                placeholder="Enter To Rate (%)"
                style={{ height: "2.2rem" }}
                onKeyDown={keyDownFocusFromApply}
              />
              {toRateValue && !validateRate(toRateValue) && (
                <div>
                  <span className="ms-2 error-style">
                    Please enter valid rate
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <ContractMaintenanceGrid
        rowData={cmType === constants?.ADMIN_RATE ? filteredRows : contracts}
        height={heightAG_1}
        cmType={cmType}
        onCellChange={(data: any, value: any) => {
          onUpdateCell(data, value);
        }}
        rateColumnDefs={currentColumnDefs}
        getGridApi={
          (gridApi:any)=>{
            setGridApi(gridApi);
          }
        }
        getColumnApi={
          (columnApi:any)=>{
            setColumnApi(columnApi);
          }
        }
      />

      <div className="d-flex justify-content-end mt-3 ">
        <div className="ms-2 h-100 d-flex align-items-center metrics-div">
          <button
            id="submit"
            className={"btn btn-primary uploadSheet-submit-Btn"}
            onClick={() => {
              updateContract();
            }}
            disabled={!isValidRequest}
          >
            Submit
          </button>
        </div>
      </div>
    </>
  );
};

export default withUser(ContractMaintenance);
